import { ApiError, apiClient } from '@/shared/api/http-client';

import type {
    CancelPlanInput,
    CreateCheckoutSessionInput,
    PaidPlans,
    SubscriptionMe,
    SubscriptionUsageHistory,
    UpdatePlanInput,
    UpdatePlanOutput,
} from '../model/subscription.types';

export type PortalTarget = 'manage-plan' | 'payment-method';

export const subscriptionApi = {
    getMe: async (signal?: AbortSignal): Promise<SubscriptionMe | null> => {
        try {
            return await apiClient.get('/subscriptions/me', signal);
        } catch (error) {
            if (error instanceof ApiError && error.status === 404) {
                return null;
            }
            throw error;
        }
    },

    getPaidPlans: async (signal?: AbortSignal): Promise<PaidPlans> => {
        return apiClient.get('/subscriptions/paid-plans', signal);
    },

    createPortalSession: async (
        returnUrl: string,
        target?: PortalTarget,
    ): Promise<{ url: string }> => {
        return apiClient.post('/subscriptions/portal', { returnUrl, target });
    },

    reactivate: async (signal?: AbortSignal): Promise<void> => {
        return apiClient.post('/subscriptions/reactivate', undefined, signal);
    },
    getUsageHistory: async (signal?: AbortSignal): Promise<SubscriptionUsageHistory> => {
        // Fetch the full window once (backend defaults to 12 months); the card filters
        // 3 / 6 / 12 months client-side, so changing the filter is instant.
        return apiClient.get('/subscriptions/usage-history', signal);
    },

    createCheckoutSession: async (input: CreateCheckoutSessionInput): Promise<{ url: string }> => {
        return apiClient.post('/subscriptions/checkout', input);
    },

    updatePlan: async (input: UpdatePlanInput): Promise<UpdatePlanOutput> => {
        return apiClient.post('/subscriptions/update-plan', input);
    },

    cancelPlan: async (input: CancelPlanInput): Promise<void> => {
        return apiClient.post('/subscriptions/cancel-plan', input);
    },
};
